// extracted by mini-css-extract-plugin
module.exports = {"rating":"_bbeb14","xs":"_525ae0"};